import React from 'react';
import { cn } from '@rocco/utils/cn';

interface Props {
    selected: boolean;
    title: React.ReactNode;
    subTitle: React.ReactNode;
    disabled?: boolean;
    onClick?: () => void;
}

const ShippingOption = ({
    selected,
    title,
    subTitle,
    disabled = false,
    onClick,
}: Props) => {
    return (
        <div
            className={cn(
                'mb-3 max-w-[375px] sm:max-w-none',
                disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
            )}
            onClick={() => !disabled && onClick?.()}
        >
            <label className="flex items-start gap-2.5">
                <span
                    className={cn(
                        'mt-1 flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full border-[1.5px]',
                        selected ? 'border-gray-900' : 'border-gray-400',
                        disabled && 'border-gray-300',
                    )}
                >
                    {selected && (
                        <span className="h-2.5 w-2.5 rounded-full bg-gray-900" />
                    )}
                </span>
                <span
                    className={cn(
                        'text-sm font-medium leading-relaxed',
                        disabled ? 'text-gray-400' : 'text-gray-800',
                    )}
                >
                    {title}
                </span>
            </label>
            <div
                className={cn(
                    'ml-7 text-xs leading-relaxed',
                    disabled ? 'text-gray-400' : 'text-gray-600',
                )}
            >
                {subTitle ?? ''}
            </div>
            {disabled && (
                <div className="ml-7 text-xs italic text-gray-400">
                    Not available
                </div>
            )}
        </div>
    );
};

export default ShippingOption;
